import('bootstrap');
export {};

//export const dummy = "This line is only needed if you see, isolatedModules issue"
